import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { UpsellItemContainer } from '../containers/UpsellItemContainer.js';

const UpsellProducts = ({ products  })=>/*#__PURE__*/ React.createElement("div", {
        className: "upsell"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "upsell__content"
    }, products.map((product)=>/*#__PURE__*/ React.createElement(UpsellItemContainer, swcHelpers.extends({
            key: product.sku
        }, product))
    )))
;

export { UpsellProducts };
//# sourceMappingURL=UpsellProducts.js.map
